import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '.';

const initialState = { currentEvent: null, cellInfo: null, anchorEl: null, events: [], loadingState: false };

const FuelCalendarSlice = createSlice({
  name: 'FuelCalendar',
  initialState,
  reducers: {
    // action creators to be auto-generated
    setcurrentEvent(state, action) {
      state.currentEvent = action.payload;
    },
    setcellInfo(state, action) {
      state.cellInfo = action.payload;
    },
    setanchorEl(state, action) {
      state.anchorEl = action.payload;
    },
    updateStateValues(state, action) {
      // console.log('action', action.payload);
      const { currentEvent, cellInfo, anchorEl } = action.payload;
      state.loadingState = true;
      state.currentEvent = currentEvent;
      state.cellInfo = cellInfo;
      state.anchorEl = anchorEl;
      state.loadingState = false;
    },
  },
});
export const fuelCalendarSelector = (state: RootState) => state.fuelCalendarState;
export const { setcurrentEvent, setcellInfo, setanchorEl, updateStateValues } = FuelCalendarSlice.actions;
const FuelCalendarReducer = FuelCalendarSlice.reducer;
export default FuelCalendarReducer;
